import React from "react";
import { useSelector } from "react-redux";
import TemplateSubmission from "../Submission/TemplateSubmission";
import AuthenticationSubmission from "../Submission/AuthenticationSubmission";

const ThirdStepMainBody = () => {
  const selectedCategory = useSelector(
    (state) => state.templateCreation.selectedCategory
  );

  switch (selectedCategory) {
    case "Utility":
      return <TemplateSubmission />;
    case "Authentication":
      return <AuthenticationSubmission />;
    case "Marketing":
      return <TemplateSubmission />;
    default:
      return <TemplateSubmission />;
  }
};

export default ThirdStepMainBody;
